import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';
import {ActivatedRoute, Router} from "@angular/router";
import {LoginExternalService} from "../../services/login-external.service";
import {AuthToken, IDictionary} from "../../common/common.types";
import {AppConfigurationService} from "../../../common/app-config/app-configuration.service";
import {AssetService} from '../../../common/services/asset.service';
import {PreLoginSystemConfigurationValues} from "../../../common/configuration/services/prelogin.system.configuration.manager";
import {LogManager} from "../../../common/log/log.manager";
import {LogCat} from "../../../common/log/log.categories";


export class BackendTokenResponse {
  success: boolean;
  token: AuthToken;
  error: string;
}

@Component({
  selector: 'app-login-external',
  templateUrl: './login-external.component.html',
  styleUrls: ['./login-external.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginExternalComponent implements OnInit, OnDestroy {

   @ViewChild("loginIframe",{static:false}) loginChild;

  private returnUrl: string;
  public  ExternalLoginSrc: SafeResourceUrl;
  public contactInfo: string;

  public errorText1 = '';
  public errorText2 = '';
  public contactInfoData = '';
  public isError = false;

  constructor(private authService: LoginExternalService,
              private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer,
              private appConfigService: AppConfigurationService,
              private assetService: AssetService,
              private changeDetector: ChangeDetectorRef,
              private sysConfig: PreLoginSystemConfigurationValues) {
    this.sysConfig.GetMainContactTelephoneAsync().subscribe(value => {
      this.contactInfo = value;
      this.changeDetector.markForCheck();
    });
  }

  ngOnInit() {
    const loginUrl = this.appConfigService.Config.externalLoginPageUrl;
    this.ExternalLoginSrc = this.sanitizer.bypassSecurityTrustResourceUrl(loginUrl);

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    // always take the first level of routing
    if (this.returnUrl !== '/') {
      this.returnUrl = '/' + this.returnUrl.split('/')[1];
    }

    if (window.addEventListener) {
      window.addEventListener('message', this.receiveMessageFromExternalLogin.bind(this), false);
    } else {
      (<any>window).attachEvent('onmessage', this.receiveMessageFromExternalLogin.bind(this));
    }
  }

  ngOnDestroy(): void {

  }

  receiveMessageFromExternalLogin(evt: MessageEvent) {
     this.resetError();
     const iframeDocument = this.loginChild.nativeElement.contentWindow;
     if (evt.source === iframeDocument) {
       if (evt.data) {
         if (this.appConfigService.Config.useBackendExternalAuthentication) {
           const tokenResponse: BackendTokenResponse = evt.data as BackendTokenResponse;
           if (tokenResponse.success) {
             this.authService.loginWithToken(tokenResponse.token).then((data) => {
               this.router.navigate([this.returnUrl]);
             }, error => {
               this.setError(error);
               this.changeDetector.markForCheck();
             });
           } else {
             this.setError(tokenResponse.error);
             this.changeDetector.markForCheck();
           };
         } else {
           const dictionary: { [index: string]: string } = evt.data as IDictionary<string>;
           this.authService.login(dictionary).then((data) => {
             this.router.navigate([this.returnUrl]);
           }, error => {
             this.setError(error);
             this.changeDetector.markForCheck();
           });
         }
       }
     }
   }

   public setError(error: string) {
     this.isError = true;
     if (error === 'PatientRecordNotFound') {
       this.errorText1 = error;
     } else {
       this.errorText1 = 'Unknown Error';
     }
     if (this.contactInfo) {
       this.errorText2 = 'PleaseContactUs';
       this.contactInfoData = this.contactInfo;
     }
     LogManager.error(LogCat.Login.ExternalLogin, `login failed: ${error}`);
   }

   public resetError() {
    this.isError = false;
    this.errorText1 = '';
    this.errorText2 = '';
    this.contactInfoData = '';
   }
}
